module.exports = __webpack_public_path__ + "img/img4.4d8eb74a.jpg";